export const getActivity = (state, res) => {
  state.activity = res
}

export const getAdvance = (state, res) => {
  state.advance = res
}

export const getSales = (state, res) => {
  state.sales = res
}

export const setFilter = (state, res) => {
  state.filter = res
}

export const setSales = (state, res) => {
  state.dSales = res
}

export const resetAdv = state => {
  state.advance = []
}

export const getGeoCustomer = (state, data) => {
  state.geoCustomer = data.data
  state.totalCustomer = data.customers
  state.geoCustomerSelected = data.data

  data.all.forEach(da => {
    da.name = da.is_customer == 1 ? 'Customer' : 'Non Customer'
  })
  state.geoCS = data.all
}

export const getGeoPB = (state, data) => {
  state.geoPB = data.data
  state.totalPB = data.pb
  state.geoPBSelected = data.data
}

export const setGeoCustomer = (state, data) => {
  state.geoCustomerSelected = data
}

export const selectGeoCustomer = (state, data) => {
  state.geoCustomerPercentage = data
}

export const setGeoPB = (state, data) => {
  state.geoPBSelected = data
}

export const getRegion = (state, data) => {
  state.regions = data
}

export const getGeoInstrument = (state, data) => {
  state.geoInstrument = data.data
  state.totalInstrument = data.count
  state.geoInstrumentSelected = data.data
}

export const setGeoInstrument = (state, data) => {
  state.geoInstrumentSelected = data
}
